import { ActionRuleParams } from '../../types';
import { formatValidation, getIslandLetter } from '../island-validation-format';
import { libLang } from '../../../../lang'
import { NotificationType } from '../../../notifications/enums';

export const islandDepthItemLimit = (params: ActionRuleParams): void => {
	const { refMap } = params;
	const { islands } = refMap
	const { notifications } = refMap.kitchen.design
	const depthLimit = 28;
	const sinkLimit = 24;

	const skus28Dpeth = ['CDPC31', 'C1SLV', 'CPOC', 'C1P28', 'C1P36', 'CWD', 'CCD-WD', 'CSSD', 'CSSD28', 'CSSD36', 'C3DC36', 'CFBTRC', 'C3-FBTRC'];

	const skus24Depth = ['CFHSINK', 'CRC'];

	notifications.purgeReferences(libLang.validations.island.size.baseDepth);
	notifications.purgeReferences(libLang.validations.island.size.sinkDepth);

	if (!islands) return

	islands.children.forEach((island) => {
		const islandDepth = typeof island.size.depth === 'number' ? island.size.depth : (island.size.depth.left || 0);
		// Evaluated independently (not else-if) so an island shallow enough to need the sink check
		// can also be shallow enough to need the 28" check — e.g. a 21.25" MOKS bar island.
		const tooShallowForSinks = islandDepth < sinkLimit;
		const tooShallowFor28 = islandDepth < depthLimit;

		if (!tooShallowForSinks && !tooShallowFor28) return;

		island.panels.children.forEach((panel) => {
			panel.panelItemGroups.children.forEach((group) => {
				group.items.children.forEach((item) => {
					const { sku } = item.item;
					if (tooShallowForSinks && skus24Depth.includes(sku)) {
						notifications.add({
							refId: island.id,
							itemRefId: item.id,
							validationCode: libLang.validations.island.size.sinkDepth,
							description: formatValidation({ letter: getIslandLetter(island), islandDescription: island.description, issue: `Will not fit ${sku} sink at ${islandDepth}" base depth` }),
							type: NotificationType.Warn
						})
					}
					if (tooShallowFor28 && skus28Dpeth.includes(sku)) {
						notifications.add({
							refId: island.id,
							itemRefId: item.id,
							validationCode: libLang.validations.island.size.baseDepth,
							description: formatValidation({ letter: getIslandLetter(island), islandDescription: island.description, issue: `Will not fit ${sku} at ${islandDepth}" base depth` }),
							type: NotificationType.Warn
						})
					}
				})
			})
		})
	})
}
